import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject, Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Campaign } from '../interfaces/campaign';
import { PlatformIdAndProvider } from '../interfaces/job-platform';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class CampaignsService {
  private _campaigns: BehaviorSubject<Campaign[]>;
  public campaigns$: Observable<Campaign[]>;
  private _expiringCampaigns: BehaviorSubject<Campaign[]>;
  public expiringCampaigns$: Observable<Campaign[]>;

  private httpClient = inject(HttpClient);

  constructor() {
    this._campaigns = new BehaviorSubject<Campaign[]>([]);
    this.campaigns$ = this._campaigns.asObservable();
    this._expiringCampaigns = new BehaviorSubject<Campaign[]>([]);
    this.expiringCampaigns$ = this._expiringCampaigns.asObservable();
  }

  getCampaigns(jobId: number) {
    const request = this.httpClient
      .get(`${environment.apiBaseUrl}/company/jobs/${jobId}/job-channels`)
      .pipe(shareReplay());
    request.pipe(untilDestroyed(this)).subscribe({
      next: (result: Campaign[]) => {
        this._campaigns.next(result);
      },
    });
    return request;
  }

  getExpiringCampaigns() {
    const request = this.httpClient.get(`${environment.apiBaseUrl}/company/expiring-job-channels`).pipe(shareReplay());
    request.pipe(untilDestroyed(this)).subscribe({
      next: (result: Campaign[]) => {
        this._expiringCampaigns.next(
          result.map((campaign, index) => {
            return {
              ...campaign,
              selectionID: index,
            };
          })
        );
      },
    });
    return request;
  }

  saveChannels(jobId: number, add: PlatformIdAndProvider[], del?: PlatformIdAndProvider[], checkoutSessionId?: string) {
    return this.httpClient.patch(`${environment.apiBaseUrl}/company/jobs/${jobId}/job-channels`, {
      add,
      delete: del,
      checkoutSessionId,
    });
  }

  publishCampaign(jobId: number, checkoutSessionId?: string) {
    return this.httpClient.post(`${environment.apiBaseUrl}/company/campaigns/jobs/${jobId}/order-campaign`, {
      checkoutSessionId,
    });
  }
}
